
/**
 * --- External Imports ---
 */
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

/**
 * --- Internal Imports ---
 */
import { GetParticipantByLabel, GetParticipantByLabelResponse } from "@/apis/dtos";
import useGet from "../apis/useGet";

/**
 * --- Hook ---
 */
const getData = (response?: SWRResponse<GetParticipantByLabelResponse, GetParticipantByLabelResponse>) => response?.data;
const getError = (response?: SWRResponse<GetParticipantByLabelResponse, GetParticipantByLabelResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetParticipantByLabelResponse, GetParticipantByLabelResponse>) => ({});

const useGetParticipantByLabel = (query?: Partial<GetParticipantByLabel>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetParticipantByLabel(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetParticipantByLabel;